<template>
    
<app-wrapper class="sort">

    <app-input-select v-model="sort" :options="options" class="sort-input" />

</app-wrapper>

</template>

<script>

export default {

    data: function() {

        return {
            sort: false
        }

    },

    watch: {

        sort: function(n) {

            this.$emit('change', n)

        }

    },   

    created: function() {

        this.sort = (this.$route.query.sort) ? this.$route.query.sort : this.$constants.sort.suggested

    },

    computed: {

        options: function() {

            var options = {}

            options[this.$constants.sort.suggested] = this.page.sort_suggested
            options[this.$constants.sort.distance] = this.page.sort_distance
            options[this.$constants.sort.reviews] = this.page.sort_reviews
            options[this.$constants.sort.rating] = this.page.sort_rating

            return options

        }

    }
    
}

</script>

<style scoped>

.sort {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.is-mobile .sort {
    flex-grow: 1;
	flex-basis: 0;
	flex-shrink: 0;
}

.sort-input {
    width: 200px!important;
	margin-bottom: 0px!important;
}

</style>